let owner: string | undefined;

/** Separate containers must never configure the same GA4 stream in one document. */
export function claimMeasurementContainer(id: string): boolean {
  if (owner && owner !== id) {
    // A full document navigation retires all old Google listeners. The persisted
    // analytics choice is retained; no customer action or form is submitted.
    window.location.reload();
    return false;
  }
  owner = id;
  return true;
}
